<template>
  <v-sheet class="bottom-sheet-wrap" style="min-height:200px; max-height:500px; overflow-y:scroll;">
    <v-list v-if="items.length > 0">
      <v-list-item-group v-model="selectedValue">
        <v-list-item v-for="(item, idx) in items" :key="idx" @click="changeItem(item, idx)">
          <v-list-item-title style="white-space:normal; line-height:1.6;">{{(nameKey && nameKey !== '') ? item[nameKey] : item.codeNm}}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list v-else>
      <v-list-item>선택 가능한 값이 없습니다</v-list-item>
    </v-list>
  </v-sheet>
</template>
<script>
export default {
  data : () => ({
    selectedValue : 0
  })
  , props : ['title', 'items', 'default', 'codeKey', 'nameKey']
  , methods : {
    changeItem(item, idx){
      this.$emit('selectItem', item);
      this.selectedValue = idx;
    }
    , changeDefaultItem(){
      if(!this.default) return;
      let codeKey = '';
      (this.codeKey && this.codeKey !== '') ? codeKey = this.codeKey : 'code';
      for(let i=0; i<this.items.length; i++){
        if(this.items[i][codeKey] === this.default){
          this.selectedValue = i;
          break;
        }
      }
    }
  }
  , mounted() {
    this.changeDefaultItem();
  }
};
</script>
<style scoped>
.theme--light.v-list-item::before{
  opacity:0;
}
.theme--light.v-list-item--active::before{
  opacity:0.12;
}
</style>